import axios from "axios";

let electronAppUrl = "http://localhost:3001";

function get_axios() {
  return axios.create({
    baseURL: electronAppUrl
  });
}

export default {
  getHardwareId() {
    return get_axios().get("/hardware-id");
  },
  getResourceUsage() {
    return get_axios().get("/resource-usage");
  },
  getMacAddress() {
    return get_axios().get("/mac-address");
  },
  //CINEPOLIS NBO BANK CARD MACHINE - DLL CALLS
  connect_nbo() {
    return get_axios().get("/NBO/connect");
  },
  purchase_nbo() {
    return get_axios().get("/NBO/connect");
  },
  purchaseFawryPay(payload) {
    return get_axios().post("/proceed-fawry-purchase", payload);
  },
  refundFawryPay(payload) {
    return get_axios().post("/proceed-fawry-refund", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ElectronAppService.js